<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="fastRect">
      <div class="title">邀请用户完善信息</div>
      <van-field
        v-model="data.picId"
        clearable
        readonly
        label="订单号"
      />
      <van-field
        v-model="data.remark"
        clearable
        readonly
        label="备注"
      />
      <van-field
        v-model="data.groupTeam"
        clearable
        readonly
        label="机构"
      />
      <van-field
        v-model="data.picTypeName"
        clearable
        readonly
        label="类型"
      />
      <van-field
        v-model="data.courseShow"
        clearable
        readonly
        label="证书"
        placeholder="请选择证书"
      />
      <van-field
        v-model="createTime"
        clearable
        readonly
        label="创建时间"
      />
      <van-field
        v-model="state"
        clearable
        readonly
        label="状态"
      />

      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>服务</span></div>
        <div class="van-cell__value"><van-checkbox v-model="data.isFastService" disabled :checked-color="GetColorMain()">急速认证 (5分钟内出证)</van-checkbox></div>
      </div>
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>实体卡</span></div>
        <div class="van-cell__value"><van-checkbox v-model="data.isPhysicsCard" disabled :checked-color="GetColorMain()">潜店定制潜水卡</van-checkbox></div>
      </div>
      <van-field
        v-model="linkUrl"
        clearable
        readonly
        label="链接"
        @click="onClickShareUrl"
      />
    </div>
    <div class="downButton">
      <van-button type="danger" :color="GetColorMain()" style="width:100%" @click="onShare">分享链接给用户</van-button>
    </div>
    <wxShare v-model="showShare" :title="shareTitle" :desc="shareAbout" :timeline="shareTimeline" :url="shareUrl" :img="shareIcon" @onFinish="onShareFinish" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Field, Switch, Popup, Checkbox } from 'vant'
import { GetSelfUrl } from '@/utils/request'
import TopBar from '@/components/TopBar'
import wxShare from '@/components/wxShare'
import { getUrlKey, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Switch.name]: Switch,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
    TopBar,
    wxShare
  },
  data() {
    return {
      titleTop: '',
      title: '分享信息完善链接',
      backurl: '/pic/picIndex',
      picId: undefined,
      createTime: '',
      state: '',
      data: {

      },
      showShare: false,
      shareTitle: '',
      shareAbout: '',
      shareTimeline: '',
      shareUrl: '',
      linkUrl: '',
      shareIcon: '',
      system: ''
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.picId = this.$route.params.id
    this.system = getUrlKey('system')
    this.init()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onShare() {
      this.showShare = true
    },
    init() {
      request({
        url: '/Pro/getPicById',
        method: 'post',
        params: { picId: this.picId }
      }).then(Response => {
        if (!Response.success) {
          return
        }
        this.data = Response.data
        this.createTime = formatDate(this.data.createTime, 'yyyy/MM/dd hh:mm', true)
        this.state = GetEnumText('Em_DivePicState', this.data.state)
        this.shareTitle = this.data.proUseName + '教练提醒你尽快完善' + this.data.picCourse + '证书信息！'
        this.shareAbout = '恭喜你完成' + this.data.picCourse + '课程，须完善信息后签发证书'
        this.shareTimeline = '恭喜你完成' + this.data.picCourse + '课程，须完善信息后签发证书'
        this.shareIcon = GetSelfUrl() + 'img/picShare.jpg'
        this.shareUrl = GetSelfUrl() + 'pic/pic/' + this.data.hashCode + '?system=' + this.system
        this.linkUrl = this.shareUrl
      })
    },
    onShareFinish() {
      this.shareUrl = undefined
    },
    onClickShareUrl() {
      window.location.href = this.linkUrl
    }
  }
}
</script>
<style scoped>
.fastRect{
    background-color: #fff;
    border-radius: 0.3em;
    padding: 0.5em;
    margin: 1em;
}
.fastRect .title{
    font-size: 1.1em;
    font-weight: 700;
    padding: 0.3em 0 0.3em 0.9em;
}
.downButton{
    margin: 1em;
}
</style>
